import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para retornar usuários responsáveis (De) da revenda.
 *
 * @param {Object} params - Parâmetros para listagem.
 * @param {boolean} params.enabled - Indica se a query deve ser executada.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @returns {Promise<any>} - Resposta da API.
 */
export function fetchResponsaveisDe({
  enabled,
  authToken,
}: {
  enabled?: boolean;
  authToken: string;
}): any {
  const fetch = async (): Promise<any> => {
    const url = "/api/autonomo/ListarEquipeAutonomoRevenda";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.post(url, {}, config);
    return response?.data?.data?.autonomos;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-revenda-responsaveis-de"],
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}

/**
 * Função para retornar usuários responsáveis (De) da revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postResponsaveisDe = async (authToken: string): Promise<any> => {
  const url = "/api/autonomo/ListarEquipeAutonomoRevenda";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, {}, config);
  return response?.data;
};
